import RecommendConceptsClient from '../clientAPI/recommendConcepts';

/**
 * Fetches multiple concepts by their IDs with error handling
 * @param conceptIds - Array of concept IDs to fetch
 * @param onError - Optional callback for error handling
 * @returns Promise resolving to array of valid concepts (null values filtered out)
 */
export async function fetchConceptsByIds(
  conceptIds: string[],
  onError?: (conceptId: string, error: any) => void,
): Promise<RecommendConcept[]> {
  const conceptQueries = conceptIds.map((id) =>
    RecommendConceptsClient.getConceptById(id).catch((err) => {
      console.error('Failed to load concept:', id, err);
      if (onError) {
        onError(id, err);
      }
      return null;
    }),
  );

  const concepts = await Promise.all(conceptQueries);
  const validConcepts = concepts.filter(
    (c): c is RecommendConcept => c !== null,
  );

  return validConcepts;
}
